import { OrderDetailsModal } from "@/features/orders/components/viewOrder/OrderDetailsModal";
import { type History, useOrder } from "@repo/api";
import { Loading } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, ModalSheet, translateOrderType } from "@repo/ui";

interface ViewOrderModalProps {
  isOpen: boolean;
  closeModal: () => void;
  orderId: string;
  historyEntries?: History[];
}

export const ViewOrderModal = ({
  isOpen,
  closeModal,
  orderId,
  historyEntries,
}: ViewOrderModalProps) => {
  const { data: order, isValidating } = useOrder(orderId);

  return (
    <ModalSheet
      title={`${order?.orderAlias ?? translateOrderType(order?.orderType)} - ${order?.orderNo ?? orderId}`}
      visible={isOpen}
      onClose={closeModal}
      onBack={orderId ? closeModal : undefined}
    >
      {isValidating && !order && (
        <FlexDiv justifyContent="center" alignItems="center">
          <Loading text={t("prompt.loading")} />
        </FlexDiv>
      )}
      {(!isValidating || order) && (
        <OrderDetailsModal order={order} historyEntries={historyEntries} />
      )}
    </ModalSheet>
  );
};
